module.exports = __webpack_public_path__ + "dfa6321539bf5cd421623cd589298b76.jpg";